import AppSettingController from "../features/Main/controller/AppSettingController";
import MarketSettingLocalStorage from "../features/Main/interface/MarketSettingLocalStorage";
import HamiService from "./connetction/HamiService";
import NetbeeService from "./connetction/NetbeeService";
import LocalService from "./connetction/LocalService";
import {ServiceInterface} from "../interfaces/ServiceInterface";

class ServiceCaller {
    private readonly serviceInstance: ServiceInterface;

    constructor() {
        const setting = AppSettingController.getSetting() as MarketSettingLocalStorage;


        switch (setting.service) {
            case "hami":
                this.serviceInstance = new HamiService();
                break;
            case "netbee":
                this.serviceInstance = new NetbeeService();
                break;
            case "localServer":
                this.serviceInstance = new LocalService();
                break;
            default:
                this.serviceInstance = new NetbeeService();
        }
    }

    getService() {
        return this.serviceInstance;
    }

    getBaseUrl() {
        return this.serviceInstance.getBaseUrl();
    }

    testBaseUrl(shopId: string): Promise<boolean> {
        return this.serviceInstance?.testBaseUrl
            ? this.serviceInstance.testBaseUrl(shopId)
            : Promise.resolve(false);
    }
}

export default ServiceCaller;
